var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("base_location_modal", {
        key: "qr",
        attrs: { extra_type: "pwa_qr", tabs_advanced: _vm.tabs_add },
        scopedSlots: _vm._u([
          {
            key: "location_general_info",
            fn: function (ref) {
              var location = ref.location
              var name = ref.name
              return [
                _c("pwa_qr_general_tab", { attrs: { location: location } }),
              ]
            },
          },
          {
            key: "pwa_location_image",
            fn: function (ref) {
              var location = ref.location
              var name = ref.name
              return [
                _c("pwa_location_image", { attrs: { location: location } }),
              ]
            },
          },
          {
            key: "pwa_qr_tab",
            fn: function (ref) {
              var location = ref.location
              var name = ref.name
              return [_c("pwa_qr_tab", { attrs: { location: location } })]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }